import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { ConfirmationService } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { GlobalLoadingComponent } from './shared/components/global-loading/global-loading.component';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { GlobalToastComponentComponent } from './shared/components/global-toast-component/global-toast-component.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { YlOverlayContainer } from './modules/admin-v3/shared/services/yl-overlay-container';
import { SessionDialogComponent } from './modules/admin-v3/shared/components/session-dialog/session-dialog.component';

// YourLeague Theme - Aura with Sky 600 primary color (Sakai-inspired)
const YourLeaguePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{sky.50}',
            100: '{sky.100}',
            200: '{sky.200}',
            300: '{sky.300}',
            400: '{sky.400}',
            500: '{sky.500}',
            600: '{sky.600}',
            700: '{sky.700}',
            800: '{sky.800}',
            900: '{sky.900}',
            950: '{sky.950}',
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}',
                },
            },
        },
    },
});

@NgModule({
    declarations: [AppComponent, GlobalLoadingComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // Admin-v3's glass "Session expired" dialog. Mounted at the app root
        // (not a route layout) because `adminV2AuthGuard` awaits the session
        // dialog before any layout mounts — same "tokens live under `.yl-app`"
        // reason `YlOverlayContainer` is wired in here.
        SessionDialogComponent,
    ],
    providers: [
        ConfirmationService,
        // Admin-v3's CDK dialogs need their overlay container inside `.yl-app`
        // to inherit the glassmorphism tokens — see YlOverlayContainer. Must be
        // root-level: CDK's Dialog/Overlay resolve OverlayContainer from root.
        { provide: OverlayContainer, useClass: YlOverlayContainer },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: YourLeaguePreset,
                options: {
                    darkModeSelector: false,
                },
            },
        }),
    ],
})
export class AppModule {}
